import React from 'react';
import { Button } from '../../Utility/Button';
import { PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react';

function Styles() {
    return (
        <>
            <h1>Styleguide</h1>

            <div>
                <h4 className="mb-8">Brand Colors</h4>
                <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div className="flex-root flex w-full flex-col gap-6">
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-950 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-950</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-900 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-900</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-800 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-800</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-700 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-700</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-600 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-600</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-500 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-500</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-400 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-400</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-300 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-300</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-200 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-200</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-100 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-100</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-primary-50 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>primary-50</p>
                            </div>
                        </div>
                    </div>
                    <div className="flex-root flex w-full flex-col gap-6">
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-950 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-950</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-900 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-900</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-800 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-800</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-700 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-700</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-600 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-600</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-500 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-500</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-400 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-400</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-300 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-300</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-200 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-200</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-100 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-100</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-secondary-50 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>secondary-50</p>
                            </div>
                        </div>
                    </div>
                    <div className="flex-root flex w-full flex-col gap-6">
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-black border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>black</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-950 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-950</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-900 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-900</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-800 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-800</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-700 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-700</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-600 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-600</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-500 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-500</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-400 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-400</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-300 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-300</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-200 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-200</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-100 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-100</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-gray-50 border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>gray-50</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-row justify-start items-center space-x-4">
                            <span className="bg-white border flex-shrink-0 h-16 w-16 rounded-full"></span>
                            <div className="space-y-1">
                                <p>white</p>
                            </div>
                        </div>
                        <div className="flex-root flex w-full flex-col gap-6"></div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-3 gap-6">
                <div>
                    <h1>
                        Headline 1<br /> Zeilenabstand
                    </h1>
                    <h2>
                        Headline 2<br /> Zeilenabstand
                    </h2>
                    <h3>
                        Headline 3<br /> Zeilenabstand
                    </h3>
                    <h4>
                        Headline 4<br /> Zeilenabstand
                    </h4>
                    <h5>
                        Headline 5<br /> Zeilenabstand
                    </h5>
                    <h6>
                        Headline 6<br /> Zeilenabstand
                    </h6>
                </div>
                <div>
                    <p>
                        Lorem ipsum
                        <a target="_self" href="http://example.com">
                            {' '}
                            Link im Text
                        </a>{' '}
                        dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor <u>invidunt</u> ut
                        labore et<b>dolore</b> <i>magna</i> aliquyam erat, sed diam voluptua.
                    </p>
                    <ul>
                        <li>Listenpunkt 1</li>
                        <li>Listenpunkt 2</li>
                        <li>Listenpunkt 3</li>
                    </ul>
                    <ol>
                        <li>Listenpunkt 1</li>
                        <li>Listenpunkt 2</li>
                        <li>Listenpunkt 3</li>
                    </ol>
                    <p></p>
                </div>
                <div>
                    <h3 className="text-fade-950">Text fade 950</h3>
                    <h3 className="text-fade-900">Text fade 900</h3>
                    <h3 className="text-fade-800">Text fade 800</h3>
                    <h3 className="text-fade-700">Text fade 700</h3>
                    <h3 className="text-fade-600">Text fade 600</h3>
                    <h3 className="text-fade-500">Text fade 500</h3>
                    <h3 className="text-fade-400">Text fade 400</h3>
                    <h3 className="text-fade-300">Text fade 300</h3>
                    <h3 className="text-fade-200">Text fade 200</h3>
                    <h3 className="text-fade-100">Text fade 100</h3>
                    <h3 className="text-fade-50">Text fade 50</h3>
                </div>
            </div>

            <div>
                <div className="grid md:grid-cols-3 gap-6">
                    <div>
                        <div className="mb-6">
                            <Button>Filled Primary</Button>
                        </div>
                        <div className="mb-6">
                            <Button variant="secondary">Filled Secondary</Button>
                        </div>
                        <div className="mb-6">
                            <Button variant="disabled">Filled Disabled</Button>
                        </div>
                    </div>
                    <div>
                        <div className="mb-6">
                            <Button variant="primaryOutlined">Primary Outline</Button>
                        </div>
                        <div className="mb-6">
                            <Button variant="secondaryOutlined">Secondary Outline</Button>
                        </div>
                        <div className="mb-6">
                            <Button variant="disabledOutlined">Disabled Outline</Button>
                        </div>
                    </div>
                    <div>
                        <div className="mb-6">
                            <Button variant="primaryRound">
                                <PencilSimpleIcon />
                            </Button>
                        </div>
                        <div className="mb-6">
                            <Button variant="secondaryRound">
                                <TrashIcon />
                            </Button>
                        </div>
                        <div className="mb-6">
                            <Button variant="disabledRound">
                                <TrashIcon />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Styles;
